// extracted by mini-css-extract-plugin
export default {"cta":"CTA_cta__lSZ2Q","container":"CTA_container__TPX+H","heading":"CTA_heading__VX1kc","text":"CTA_text__Mq2vP"};